import { NavLink } from 'react-router';

interface LinkProps extends React.ComponentProps<'a'> {
  href: string;
}

export function Link({ href, children, ...props }: LinkProps) {
  return (
    <NavLink to={href} {...props}>
      {children}
    </NavLink>
  );
}
